import { render, staticRenderFns } from "./paydetailrecords.vue?vue&type=template&id=3b4b3e4c&scoped=true&"
import script from "./paydetailrecords.vue?vue&type=script&lang=js&"
export * from "./paydetailrecords.vue?vue&type=script&lang=js&"
import style0 from "./paydetailrecords.vue?vue&type=style&index=0&id=3b4b3e4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4b3e4c",
  null
  
)

export default component.exports